
import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { HeaderInfo, NavigationButton } from './HeaderInfo';
import { ResponseContent } from './ResponseContent';
import { DialogueItem } from './types';
import { formatInterfaithResponse } from './ContentFormatter';
import { ResponseActions } from '@/components/Dashboard/utils/toolUtils';

export const renderInterfaithDialogueContent = (item: any, navigate: NavigateFunction) => {
  if (!item || !item.content) {
    console.log("No content available for item:", item);
    return <p>No content available</p>;
  }

  // Ensure all possible fields exist with fallbacks
  const typedItem: DialogueItem = {
    content: {
      faithGroup: item.content.faithGroup || 'N/A',
      question: item.content.question || 'N/A',
      response: item.content.response || null
    }
  };
  
  // Process and clean the response data to remove duplicates
  const processedItem = formatInterfaithResponse(typedItem);
  
  if (!processedItem) {
    return <p>Error processing response data</p>;
  }

  return (
    <div className="space-y-6">
      {/* Header Information */}
      <HeaderInfo item={processedItem} navigate={navigate} />
      
      {/* Response Content */}
      <ResponseContent item={processedItem} navigate={navigate} />
      
      {/* Actions for saving and sharing */}
      {processedItem.content.response && (
        <ResponseActions 
          question={processedItem.content.question}
          response={processedItem.content.response}
          toolType="interfaith_dialogue"
        />
      )}
      
      {/* Navigation Button */}
      <NavigationButton item={processedItem} navigate={navigate} />
    </div>
  );
};
